<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Logs
      </b-card-header>
      <b-card-body>
        <div class="search-box">
          <b-form-group class="search-condition">
            <b-form-input v-model="searchOption.action"
              placeholder="Enter action"
              class="date-picker"
              :plain="true">
            </b-form-input>
          </b-form-group>
          <b-form-group class="search-condition">
            <range-date-picker :initRange="initRange" @selected="onDateSelected" class="date-picker" />
          </b-form-group>
          <b-button type="submit" variant="primary" class="btn-pill" @click.stop="search">
            <i class="fa fa-search"></i>&nbsp;Search
          </b-button>
        </div>        
        <Logs :key="componentKey" :searchOption="searchOption"/>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import RangeDatePicker from '../../components/RangeDatePicker'
  import { utils } from '../../mixins/utils'
  import Logs from '../logs/Logs'

  export default {
    name: 'LogList',
    mixins: [utils],
    components: {
      RangeDatePicker,
      Logs
    },
    data: function() {
      return {
        componentKey: 0,
        searchOption: {
          action: null,
          createdFrom: null,
          createdTo: null
        },
      }
    },
    computed: {
      initRange() {
        return {
          start: this.$moment(this.searchOption.createdFrom, 'YYYY-MM-DD').startOf('day').toDate(),
          end: this.$moment(this.searchOption.createdTo, 'YYYY-MM-DD').endOf('day').toDate(),
        }
      }
    },
    created() {
      this.initSearchOptionFromQuery()
      this.updateUrl()
    },    
    methods: {
      onDateSelected(selected) {
        console.info('from:' + selected.start + ' to:' + selected.end)
        this.searchOption.createdFrom = selected.start
        this.searchOption.createdTo = selected.end
      },
      initSearchOptionFromQuery() {
        if (this.$route.query.hasOwnProperty('action')) this.searchOption.action = this.$route.query.action
        Object.assign(this.searchOption, this.$route.query)
        if (this.isValidQueryCreatedDate(this.searchOption)) return
        this.searchOption.createdFrom = this.$moment(this.$store.getters.lastDateRange.start).format('YYYY-MM-DD')
        this.searchOption.createdTo = this.$moment(this.$store.getters.lastDateRange.end).format('YYYY-MM-DD')
      },
      updateUrl() {
        const query = JSON.parse(JSON.stringify(this.$route.query))
        if (this._.isEqual(query, this.searchOption)) return

        console.log('replace query', query, this.searchOption)
        this.$router.replace({ path: this.$route.path, query: this.searchOption })
        console.log('replace route query', this.$route.query)
      },
      search() {
        console.info('search() ', this.searchOption)
        this.updateUrl()
        this.componentKey += 1
      }
    }    
  };
</script>
